import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'

import Avatar from '../../../Avatar'
import { getAssetLink } from '../../../helpers/get-asset-link'
import { getProperRole } from '../../../helpers/helpers'
import { selectStaffPersons } from '../../../reducers/maintenanceStaffReducer'
import { selectParkingStaffUsers } from '../../../reducers/Organisation/parkingStaffReducer'
import { selectPropertyManagers } from '../../../reducers/Organisation/propertyManagersReducer'
import { selectShiftManagers } from '../../../reducers/Organisation/shiftManagersReducer'
import { selectValetUsers } from '../../../reducers/Organisation/valetReducer'
import { selectUserData } from '../../../reducers/userDataReducer'
import CollectionItem from '../../Collection/CollectionItem'
import CollectionList from '../../Collection/CollectionList'
import { ManagementUser, ManagementUsersListProps, UserCore } from './types'

const ManagementUsersList = ({
  isLoading,
  managementUsersLoading,
  selectedFilterRoles,
  selectManagementUser,
}: ManagementUsersListProps) => {
  const { buildingId, userId } = useParams<{ buildingId?: string; userId?: string }>()

  // Selectors – no type global store yet:
  const shiftManagers = useSelector(selectShiftManagers) as unknown as ManagementUser[]
  const propertyManagers = useSelector(selectPropertyManagers) as unknown as ManagementUser[]
  const staffPeople = useSelector(selectStaffPersons) as unknown as ManagementUser[]
  const valetUsers = useSelector(selectValetUsers) as unknown as ManagementUser[]
  const parkingStaffUsers = useSelector(selectParkingStaffUsers) as unknown as ManagementUser[]
  const currentUser = useSelector(selectUserData) as unknown as { user: UserCore }

  const [selectedManagementUser, setSelectedManagementUser] = useState<ManagementUser | null>(null)

  const managementUsers: ManagementUser[] = [
    ...shiftManagers,
    ...propertyManagers,
    ...staffPeople,
    ...valetUsers,
    ...parkingStaffUsers,
  ]

  const roles = selectedFilterRoles.map((role) => role.name)

  return (
    <>
      {isLoading || managementUsersLoading ? (
        <div className="is-loading" style={{ marginTop: '50%' }} />
      ) : (
        <CollectionList>
          {managementUsers
            .filter((u) => u.user.id !== currentUser.user.id)
            .filter((u) => (roles.length ? roles.includes(u.user.role) : true))
            .map((managementUser, index) => (
              <Link
                key={`${managementUser.user.id}_${index}`}
                to={`/dashboard/building-dashboard/management-users/${buildingId}/selected-user`}
                onClick={() => {
                  setSelectedManagementUser(managementUser)
                  selectManagementUser(managementUser)
                }}
              >
                <CollectionItem
                  mark
                  rounded
                  isHighlight={
                    selectedManagementUser && userId !== 'new'
                      ? selectedManagementUser.id === managementUser.id
                      : undefined
                  }
                >
                  <Avatar size="big">
                    <img
                      alt=""
                      src={getAssetLink({
                        file: managementUser.user.avatar,
                        path: 'chitown-avatar/avatar',
                      })}
                    />
                  </Avatar>
                  <strong>
                    {managementUser.user.firstName} {managementUser.user.lastName}
                  </strong>
                  <span>{managementUser.user.email}</span>
                  <span>{getProperRole(managementUser.user.role)}</span>
                </CollectionItem>
              </Link>
            ))}
        </CollectionList>
      )}
    </>
  )
}

export default ManagementUsersList
